"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
var ntimer_1 = require("ntimer");
var Logger_1 = require("../Logger");
var uniqId_1 = require("./uniqId");
/**
 * @hidden
 */
var Log = Logger_1.default("Timers");
/**
 * @hidden
 */
var Timers = /** @class */ (function (_super) {
    __extends(Timers, _super);
    function Timers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timers = {};
        return _this;
    }
    /**
     * Creates a auto starting timer with the given timeout and returns its
     * name. If a name is not supplied, a random name is generated.
     *
     * If a timer with the name exists, it is cancelled and a
     * new timer is installed
     *
     * @param timeout
     *
     * @return {module:ntimer.Timer} timer
     * @param opts
     * @param n
     */
    Timers.prototype.create = function (timeout, n, opts) {
        var that = this;
        var name = n || uniqId_1.uniqId();
        Log.i("create", timeout, name, opts);
        this.cancel(name);
        var t = this.timers[name] = new ntimer_1.Timer({ name: name, timeout: timeout, auto: true });
        t.on("timer", function () { return that.cancel(name); });
        this.emit('createTimer', timeout, name);
        return t;
    };
    /**
     * Cancels and existing timer and removes it from the list
     * Does nothing if the named timer is not in the list
     *
     * @param name, the timer's name
     * @return {boolean} true if the timer was found and cancelled
     */
    Timers.prototype.cancel = function (name) {
        if (!this.timers[name]) {
            return false;
        }
        Log.i("cancel", name);
        this.timers[name].cancel();
        delete this.timers[name];
        this.emit('cancelTimer', name);
        return true;
    };
    /**
     * Gets the named timer
     * @param name
     */
    Timers.prototype.get = function (name) {
        return this.timers[name];
    };
    return Timers;
}(events_1.EventEmitter));
exports.default = Timers;
//# sourceMappingURL=Timers.js.map